/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-useless-escape */
import React, { Component } from "react";
import { connect } from "react-redux";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import ReCAPTCHA from "react-google-recaptcha";
import { ReCAPTCHA_KEY } from "../../configs/const";
import * as authServices from "../../services/authService";
import * as xoroService from "../../services/xoroService";

import * as accountServices from "../../services/accountService";
import { staticContentsImagePathOnly as BASE_IMAGE_PATH_ONLY } from "../../configs/const";
import { ISOTPPASSWORD, LoginAndRegisterHaveURL, OTPVia } from "../../configs/authSignupConfig";
import { APK_FILE_NAME } from '../../configs/apkFileName';
import { LBLTYPE, LoginWithDemo, PotanuCaptcha } from "../../configs/casinoShowList";
import CaptchaComp from "./captchaComp";
import { logout } from "../../util/auth.util";
let sendotpintervallg;
const recaptchaRef = React.createRef();
class Loginpopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: false,
      uid: "",
      passcode: "",
      passcodeVisible: false,
      passcodeforgot: "",
      rememberMe: false,
      forgotPassword: false,
      usernameforgot: "",
      mobileNumber: "",
      mobileNumberCountryCode: "",
      mobileNumberisValid: false,
      buttonLoader: false,
      clientWidth: document.documentElement.clientWidth,
      setPassword: false,
      setpwdpasscode: "",
      setpwdoldpasscode: "",
      setpwdrepasscode: "",
      setpwdpasscodeVisible: false,
      setpwdoldpasscodeVisible: false,
      setpwdrepasscodeVisible: false,
      otpSent: 0,
      otpSentTo: "",
      resendOtp: 0,
      fgtOtp: "",
      fgtpwdpasscode: "",
      fgtpwdrepasscode: "",
      fgtpwdpasscodeVisible: false,
      fgtpwdrepasscodeVisible: false,
      otpsentnumber: "",
      requestId: null,
      captchaSolution: '',
      expiryCaptcha: 0,
      demoButtonLoader: false,
    };
  }
  componentDidMount() {
    this.setState({ setPassword: !!this.props.pwdch ? this.props.pwdch : false });
  }
  componentWillUnmount() {
    clearInterval(sendotpintervallg);
  }
  clean(obj) {
    for (var propName in obj) {
      if (obj[propName] === undefined) {
        delete obj[propName];
      }
    }
    return obj;
  }

  onChange(e) {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value }, () => {
      if (
        name === "usernameforgot" &&
        this.state.otpSent > 0 &&
        this.state.usernameforgot !== this.state.otpSentTo
      ) {
        clearInterval(sendotpintervallg);
        if (!!document.getElementById("digit")) {
          document.getElementById("digit").className = "";
          document.getElementById("scharacter").className = "";
          document.getElementById("minlength").className = "";
        }
        this.setState({
          otpSent: 0,
          otpSentTo: "",
          resendOtp: 0,
          fgtOtp: "",
          fgtpwdpasscode: "",
          fgtpwdrepasscode: "",
          fgtpwdpasscodeVisible: false,
          fgtpwdrepasscodeVisible: false,
          otpsentnumber: "",
        });
      }
      if ((name === "setpwdpasscode" || name === "fgtpwdpasscode") && !!value) {
        if (value.match(/[0-9]/g)) {
          document.getElementById("digit").className = "success-text";
        } else {
          document.getElementById("digit").className = "";
        }
        if (value.match(/[a-zA-Z]/g)) {
          document.getElementById("scharacter").className = "success-text";
        } else {
          document.getElementById("scharacter").className = "";
        }
        if (value.length >= 8) {
          document.getElementById("minlength").className = "success-text";
        } else {
          document.getElementById("minlength").className = "";
        }
        //   if (value === this.state.oldpasscode) {
        //     document.getElementById("notold").className = "error-text d-block"
        //   } else {
        //     document.getElementById("notold").className = "error-text d-none"
        //   }
        //   if (value.toLowerCase().indexOf(this.state.uid.toLowerCase()) !== -1) {
        //     document.getElementById("notuser").className = "error-text d-block"
        //   } else {
        //     document.getElementById("notuser").className = "error-text d-none"
        //   }
      }
    });
  }

  handleKey(e) {
    if (e.keyCode === 13) {
      this.signIn();
    }
  }

  handleSetPasswordKey(e) {
    if (e.keyCode === 13) {
      this.setPasswordSubmit();
    }
  }

  signIn() {
    const self = this;
    // if (recaptchaRef.current.getValue() === "") {
    //   this.props.notify("Attend Captcha", "warning");
    // } else {

    if (!this.state.uid.trim()) {
      this.props.notify("Please Insert Username!", "error");
      return false;
    }
    if (!this.state.passcode.trim()) {
      this.props.notify("Please Insert Password!", "error");
      return false;
    }
    if (this.state.rememberMe) {
      let data = {
        uid: this.state.uid.trim().toLowerCase(),
        passcode: this.state.passcode.trim(),
      };
      localStorage.setItem("rememberData", JSON.stringify(data));
    } else {
      localStorage.removeItem("rememberData");
    }

    let body = {
      username: this.state.uid.trim().toLowerCase(),
      password: this.state.passcode.trim(),
    };
    if(PotanuCaptcha){
      if (!(!!this.state.captchaSolution)) {
        this.props.notify("Solve Captcha to move ahead", "error");
        return false;
      }
  
    //   if (this.state.expiryCaptcha < new Date().getTime()) {
    //     this.props.notify("Captcha is expired, Click Refresh.", "error");
    //     document.getElementById('iCaptchaRefresh').click()
    //     return false;
    //   }
      
      body['requestId'] = this.state.requestId;
      body['captchaAnswer'] = this.state.captchaSolution;
    }


    this.signInApi(body);
    // }
  }

  signInApi(body, loginwithdemo = false) {
    const self = this;
    this.setState({ buttonLoader: !loginwithdemo, demoButtonLoader: loginwithdemo }, () => {
      authServices.signin(body,loginwithdemo).then(async (result) => {
        // self.setState({buttonLoader: false});
        if (result.token) {
          let data = {
            token: result.token,
          };
          let accessControl = {
            sports: true,
            binary: true,
            casino: true,
          };
          localStorage.setItem("userAuthDetail", JSON.stringify(data));
          let velidateData = await authServices.velidateToken();

          if (!!velidateData.role && (velidateData.role === "Client"||velidateData.role === "DemoClient")) {
            // let xoroData = await xoroService.getXoroData();
            // if(!!xoroData && xoroData.isSuccess) {
            //   xoroData = xoroData.data
            // }
            // localStorage.setItem("xoroData", JSON.stringify(xoroData));
            localStorage.setItem("tokenData", JSON.stringify(velidateData));
            localStorage.setItem(
              "accessControl",
              JSON.stringify(accessControl)
            );
            let accData = await accountServices.getAccountData();
            if (!!accData && !!accData.userLock && accData.userLock) {
              self.props.notify(
                "User Is Locked. Please Contact Upperline!",
                "error"
              );
              self.logout();
            }
            localStorage.setItem("accountData", JSON.stringify(accData));
            let configData = await authServices.getConfigButton();
            localStorage.setItem("buttonsValues", JSON.stringify(configData));
            localStorage.removeItem('homeData');
            localStorage.removeItem('eventMenuDetails');
            if (velidateData.pwdch) {
              self.setState({ buttonLoader: false, demoButtonLoader: false });
              self.setState({ setPassword: true }, () => {
                document.getElementById("setpwdoldpasscode").focus();
              });
            } else {

              let profData = await accountServices.getProfileData(this.state.uid);

              profData = JSON.stringify(profData)
              localStorage.setItem("profData", profData)

              // this.props.history.push("/home");
              self.setState({ buttonLoader: false, demoButtonLoader: false });
              self.props.hidePopup("Login");
              window.location.reload(); //= window.location.href;//"/home";
            }
          } else if (!!velidateData.role && !["Client", "DemoClient"].includes(velidateData.role) ) {
            self.props.notify(
              velidateData.role + " user is not allow to access this portal.",
              "error"
            );
            document.getElementById('iCaptchaRefresh').click()
          } else {
            self.props.notify(velidateData.exception.message, "error");
            document.getElementById('iCaptchaRefresh').click()
          }
        } else {
          self.setState({ buttonLoader: false, demoButtonLoader: false });
          self.props.notify(result.exception.message, "error");
          document.getElementById('iCaptchaRefresh').click()
        }
      });
    });
  }

  validateForSubmit() {
    return this.state.uid === "" || this.state.passcode === "";
  }

  onPasswordVisible(id) {
    if (!!this.state[`${id}Visible`]) {
      document.getElementById(id).type = "Password";
    } else {
      document.getElementById(id).type = "text";
    }
    this.setState({ [`${id}Visible`]: !this.state[`${id}Visible`] });
  }

  submitForgotPassword() {
    const self = this;
    if(( this.state.usernameforgot.trim() === "" || this.state.usernameforgot.trim().length < 6 || (ISOTPPASSWORD === true ? this.state.fgtOtp === "" || this.state.fgtOtp.length !== 6: false) || !(this.state.fgtpwdpasscode.match(/[0-9]/g)) || !(this.state.fgtpwdpasscode.match(/[a-zA-Z]/g)) || !(this.state.fgtpwdpasscode.length >= 8) || this.state.fgtpwdpasscode.toLowerCase().indexOf(this.state.uid.toLowerCase()) === -1 )){
      return false;
    }
    if(this.state.fgtpwdpasscode !== this.state.fgtpwdrepasscode){
      this.props.notify("Confirm password does not match!", "error");
      return false;
    }
    let body = {
      username: this.state.usernameforgot.trim().toLowerCase(),
      otp: this.state.fgtOtp,
      password: this.state.fgtpwdpasscode,
    };
    this.setState({ buttonLoader: true }, () => {
      authServices.forgetPassword(body).then(async (result) => {
        self.setState({ buttonLoader: false });
        if (result.isSuccess) {
          // self.props.notify("Registered successfully!", "success")
          self.props.showSweetAlert({
            icon: "success",
            title: "Congratulations",
            html: "Password changed sucessfully.",
            //text: 'Confirmed! You’re in!,Please login.',
            // footer: 'We are glad that you joined us.'
          });
          self.setState({
            usernameforgot: '',
            fgtOtp: '',
            fgtpwdpasscode: '',
            fgtpwdrepasscode: '',
            forgotPassword: false,
            otpSent:0,
          })
          // self.props.hidePopup("Login");
          // let body = {
          //   username: self.state.usernameforgot.trim().toLowerCase(),
          //   password: self.state.fgtpwdpasscode,
          // };
          // self.signInApi(body);
        } else {
          self.props.notify(result.exception.message, "error");
        }
      });
    });
  }

  validateForForgot() {
    // return this.state.usernamesignup === "" || this.state.usernamesignup.length < 6 || this.state.passwordsignup === "" || this.state.passwordsignup_confirm === "" || !(this.state.passwordsignup.match(/[0-9]/g)) || !(this.state.passwordsignup.match(/[a-zA-Z]/g)) || this.state.passwordsignup.length < 8 || this.state.passwordsignup.toLowerCase().indexOf(this.state.usernamesignup.toLowerCase()) > -1 || this.state.passwordsignup !== this.state.passwordsignup_confirm || this.state.mobileNumber === "" || this.state.mobilealreadyexist || !this.state.mobileNumberisValid || (!this.state.sameAsMobile && (this.state.whatsUpNumber === "" || !this.state.whatsUpNumberisValid)) || this.state.emailsignup === "" || !(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.state.emailsignup.trim())) || !this.state.tncChecked || this.state.usernamealreadyexist
    return (
      this.state.usernameforgot.trim() === "" ||
      this.state.usernameforgot.trim().length < 6 ||
      (ISOTPPASSWORD === true
        ? this.state.fgtOtp === "" || this.state.fgtOtp.length !== 6
        : false) ||
      !(this.state.fgtpwdpasscode.match(/[0-9]/g)) ||
      !(this.state.fgtpwdpasscode.match(/[a-zA-Z]/g)) ||
      !(this.state.fgtpwdpasscode.length >= 8) ||
        this.state.fgtpwdpasscode
          .toLowerCase()
          .indexOf(this.state.uid.toLowerCase()) === -1 
          // || this.state.fgtpwdpasscode !== this.state.fgtpwdrepasscode
    );
    //return false;
  }

  checkPhoneNumberValidity(countryCode, value) {
    const phonesregex = {
      AM: /^(\+?374|0)((10|[9|7][0-9])\d{6}$|[2-4]\d{7}$)/,
      AE: /^((\+?971)|0)?5[024568]\d{7}$/,
      AZ: /^\+?[1-9]{1}[0-9]{3,14}$/,
      BH: /^(\+?973)?(3|6)\d{7}$/,
      DZ: /^(\+?213|0)(5|6|7)\d{8}$/,
      EG: /^((\+?20)|0)?1[0125]\d{8}$/,
      IQ: /^(\+?964|0)?7[0-9]\d{8}$/,
      JO: /^(\+?962|0)?7[789]\d{7}$/,
      KW: /^(\+?965)[569]\d{7}$/,
      SA: /^(!?(\+?966)|0)?5\d{8}$/,
      SY: /^(!?(\+?963)|0)?9\d{8}$/,
      TN: /^(\+?216)?[2459]\d{7}$/,
      BY: /^(\+?375)?(24|25|29|33|44)\d{7}$/,
      BG: /^(\+?359|0)?8[789]\d{7}$/,
      BD: /^(\+?880|0)1[13456789][0-9]{8}$/,
      CZ: /^(\+?420)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
      DK: /^(\+?45)?\s?\d{2}\s?\d{2}\s?\d{2}\s?\d{2}$/,
      DE: /^(\+49)?0?1(5[0-25-9]\d|6([23]|0\d?)|7([0-57-9]|6\d))\d{7}$/,
      AT: /^(\+43|0)\d{1,4}\d{3,12}$/,
      GR: /^(\+?30|0)?(69\d{8})$/,
      AU: /^(\+?61|0)4\d{8}$/,
      GB: /^(\+?44|0)7\d{9}$/,
      GG: /^(\+?44|0)1481\d{6}$/,
      GH: /^(\+?233|0)(20|50|24|54|55|59|25|27|57|26|56|23|28)\d{7}$/,
      HK: /^(\+?852[-\s]?)?[456789]\d{3}[-\s]?\d{4}$/,
      MO: /^(\+?853[-\s]?)?[6]\d{3}[-\s]?\d{4}$/,
      IE: /^(\+?353|0)8[356789]\d{7}$/,
      IN: /^(\+?91|0)?[6789]\d{9}$/,
      KE: /^(\+?254|0)(7|1)\d{8}$/,
      MT: /^(\+?356|0)?(99|79|77|21|27|22|25)[0-9]{6}$/,
      MU: /^(\+?230|0)?\d{8}$/,
      NG: /^(\+?234|0)?[789]\d{9}$/,
      NZ: /^(\+?64|0)[28]\d{7,9}$/,
      PK: /^((\+?92)|(0092))-{0,1}\d{3}-{0,1}\d{7}$|^\d{11}$|^\d{4}-\d{7}$/,
      RW: /^(\+?250|0)?[7]\d{8}$/,
      SG: /^(\+65)?[89]\d{7}$/,
      SL: /^(?:0|94|\+94)?(7(0|1|2|5|6|7|8)( |-)?\d)\d{6}$/,
      TZ: /^(\+?255|0)?[67]\d{8}$/,
      UG: /^(\+?256|0)?[7]\d{8}$/,
      US: /^((\+1|1)?( |-)?)?(\([2-9][0-9]{2}\)|[2-9][0-9]{2})( |-)?([2-9][0-9]{2}( |-)?[0-9]{4})$/,
      ZA: /^(\+?27|0)\d{9}$/,
      ZM: /^(\+?26)?09[567]\d{7}$/,
      CL: /^(\+?56|0)[2-9]\d{1}\d{7}$/,
      EC: /^(\+?593|0)([2-7]|9[2-9])\d{7}$/,
      ES: /^(\+?34)?(6\d{1}|7[1234])\d{7}$/,
      MX: /^(\+?52)?(1|01)?\d{10,11}$/,
      PA: /^(\+?507)\d{7,8}$/,
      PY: /^(\+?595|0)9[9876]\d{7}$/,
      UY: /^(\+598|0)9[1-9][\d]{6}$/,
      EE: /^(\+?372)?\s?(5|8[1-4])\s?([0-9]\s?){6,7}$/,
      IR: /^(\+?98[\-\s]?|0)9[0-39]\d[\-\s]?\d{3}[\-\s]?\d{4}$/,
      FI: /^(\+?358|0)\s?(4(0|1|2|4|5|6)?|50)\s?(\d\s?){4,8}\d$/,
      FJ: /^(\+?679)?\s?\d{3}\s?\d{4}$/,
      FO: /^(\+?298)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
      FR: /^(\+?33|0)[67]\d{8}$/,
      GF: /^(\+?594|0|00594)[67]\d{8}$/,
      GP: /^(\+?590|0|00590)[67]\d{8}$/,
      MQ: /^(\+?596|0|00596)[67]\d{8}$/,
      RE: /^(\+?262|0|00262)[67]\d{8}$/,
      IL: /^(\+972|0)([23489]|5[012345689]|77)[1-9]\d{6}$/,
      HU: /^(\+?36)(20|30|70)\d{7}$/,
      ID: /^(\+?62|0)8(1[123456789]|2[1238]|3[1238]|5[12356789]|7[78]|9[56789]|8[123456789])([\s?|\d]{5,11})$/,
      IT: /^(\+?39)?\s?3\d{2} ?\d{6,7}$/,
      JP: /^(\+81[ \-]?(\(0\))?|0)[6789]0[ \-]?\d{4}[ \-]?\d{4}$/,
      KZ: /^(\+?7|8)?7\d{9}$/,
      GL: /^(\+?299)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
      KR: /^((\+?82)[ \-]?)?0?1([0|1|6|7|8|9]{1})[ \-]?\d{3,4}[ \-]?\d{4}$/,
      LT: /^(\+370|8)\d{8}$/,
      MY: /^(\+?6?01){1}(([0145]{1}(\-|\s)?\d{7,8})|([236789]{1}(\s|\-)?\d{7}))$/,
      NO: /^(\+?47)?[49]\d{7}$/,
      NP: /^(\+?977)?9[78]\d{8}$/,
      BE: /^(\+?32|0)4?\d{8}$/,
      NL: /^(\+?31|0)6?\d{8}$/,
      PL: /^(\+?48)? ?[5-8]\d ?\d{3} ?\d{2} ?\d{2}$/,
      BR: /(?=^(\+?5{2}\-?|0)[1-9]{2}\-?\d{4}\-?\d{4}$)(^(\+?5{2}\-?|0)[1-9]{2}\-?[6-9]{1}\d{3}\-?\d{4}$)|(^(\+?5{2}\-?|0)[1-9]{2}\-?9[6-9]{1}\d{3}\-?\d{4}$)/,
      PT: /^(\+?351)?9[1236]\d{7}$/,
      RO: /^(\+?4?0)\s?7\d{2}(\/|\s|\.|\-)?\d{3}(\s|\.|\-)?\d{3}$/,
      RU: /^(\+?7|8)?9\d{9}$/,
      SI: /^(\+386\s?|0)(\d{1}\s?\d{3}\s?\d{2}\s?\d{2}|\d{2}\s?\d{3}\s?\d{3})$/,
      SK: /^(\+?421)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
      RS: /^(\+3816|06)[- \d]{5,9}$/,
      SE: /^(\+?46|0)[\s\-]?7[\s\-]?[02369]([\s\-]?\d){7}$/,
      TH: /^(\+66|66|0)\d{9}$/,
      TR: /^(\+?90|0)?5\d{9}$/,
      UA: /^(\+?38|8)?0\d{9}$/,
      VN: /^(\+?84|0)((3([2-9]))|(5([2689]))|(7([0|6-9]))|(8([1-6|89]))|(9([0-9])))([0-9]{7})$/,
      CN: /^((\+|00)86)?1([358][0-9]|4[579]|6[67]|7[01235678]|9[189])[0-9]{8}$/,
      TW: /^(\+?886\-?|0)?9\d{8}$/,
      GE: /^(\+?995\-?|0)?[3457]\d{8}$|[3457]\d{9}$/,
      LK: /^(?:7|0|(?:94))[0-9]{9,10}$/
    };
    let valid = false;

    const countryRegex = phonesregex[countryCode];
    if (!!countryRegex) {
      valid = countryRegex.test(value);
    }

    return valid;
  }

  onPhoneNumberChange(inputNumber, country, name) {
    this.setState({
      [name]: inputNumber,
      [`${name}CountryCode`]: country.countryCode.toUpperCase(),
      [`${name}isValid`]: this.checkPhoneNumberValidity(
        country.countryCode.toUpperCase(),
        inputNumber
      ),
    });
  }

  sendOTP(resend = false) {
    const self = this;
    if (
      !(
        this.state.usernameforgot.trim() === "" || this.state.usernameforgot.trim().length < 6
      )
    ) {
      const body = {
        username: this.state.usernameforgot.trim().toLowerCase(),
        isSignupPage: false,
        isResend: resend,
      };
      if(OTPVia === 'mobile'){
        body['mobile'] = "";
      }
      authServices.sendOTP(body).then(async (result) => {
        if (!!result && !!result.isSuccess && result.isSuccess) {
          const otpSent = self.state.otpSent + 1;
          self.setState(
            {
              otpSent: otpSent,
              otpSentTo: self.state.usernameforgot.trim().toLowerCase(),
              resendOtp: 60,
              otpsentnumber: result.data.mobile,
            },
            () => {
              self.sendOtpIntervalLGStart();
            }
          );
        } else {
          self.props.notify(result.exception.message, "error");
        }
      });
    }
  }

  sendOtpIntervalLGStart() {
    const self = this;
    sendotpintervallg = setInterval(async function sendotpintervallgagain() {
      clearInterval(sendotpintervallg);
      if (self.state.resendOtp > 0) {
        // debugger
        const resendOtp = self.state.resendOtp - 1;
        self.setState({ resendOtp: resendOtp }, () => {
          sendotpintervallg = setInterval(sendotpintervallgagain, 1000);
          return false;
        });
      }
    }, 1000);
  }

  async setPasswordSubmit() {
    if (!this.state.setpwdoldpasscode) {
      this.props.notify("Please insert old password!", "error");
      return false;
    }
    if (!this.state.setpwdpasscode) {
      this.props.notify("Please insert new password!", "error");
      return false;
    }
    if (this.state.setpwdpasscode.length < 8) {
      this.props.notify("Password must have atleast 8 digit!", "error");
      return false;
    }
    if(!this.state.setpwdpasscode.match(/[0-9]/g) || !this.state.setpwdpasscode.match(/[a-zA-Z]/g)){
      this.props.notify("Password must be AlphaNumeric!", "error");
      return false;
    }
    if (
      this.state.setpwdpasscode !== "" &&
      this.state.setpwdpasscode !== this.state.setpwdrepasscode
    ) {
      this.props.notify("Confirm password does not match!", "error");
      return false;
    }
    if (
      this.state.setpwdoldpasscode === this.state.setpwdpasscode
    ) {
      this.props.notify("New password Cannot be same as Old password!", "error");
      return false;
    }
    let body = {
      OldPassword: this.state.setpwdoldpasscode,
      NewPassword: this.state.setpwdpasscode,
      ConfirmPassword: this.state.setpwdrepasscode,
    };
    authServices.setPassword(body).then((res) => {
      if (res.isSuccess) {
        let appType = localStorage.getItem("appType");
        // if (appType === "mobile") {
        //   this.props.history.push("/apk");
        // } else {
        //   this.props.history.push("/auth");
        // }
        this.setState(
          {
            uid: "",
            passcode: "",
            passcodeVisible: false,
            rememberMe: false,
            forgotPassword: false,
            usernameforgot: "",
            mobileNumber: "",
            mobileNumberCountryCode: "",
            mobileNumberisValid: false,
            buttonLoader: false,
            setPassword: false,
            setpwdpasscode: "",
            setpwdoldpasscode: "",
            setpwdrepasscode: "",
            setpwdpasscodeVisible: false,
            setpwdoldpasscodeVisible: false,
            setpwdrepasscodeVisible: false,
          },
          () => {
            let tkdata = localStorage.getItem('tokenData');
            if (!!tkdata) {
              tkdata = JSON.parse(tkdata);
              tkdata.pwdch = false;
              localStorage.setItem('tokenData', JSON.stringify(tkdata));
            }

            this.afterSetPassword();
          }
        );
      } else {
        this.props.notify(res.exception.message, "error");
      }
    });
  }

  async afterSetPassword() {
    let profData = await accountServices.getProfileData(this.state.uid);

    profData = JSON.stringify(profData)
    localStorage.setItem("profData", profData)

    // this.props.history.push("/home");
    this.setState({ buttonLoader: false });
    this.props.hidePopup("Login");
    window.location.reload();
    this.props.notify("Password set successfull.", "success");
    this.props.hidePopup("Login");
  }

  validateForSetupPassword() {
    // return this.state.usernamesignup === "" || this.state.usernamesignup.length < 6 || this.state.passwordsignup === "" || this.state.passwordsignup_confirm === "" || !(this.state.passwordsignup.match(/[0-9]/g)) || !(this.state.passwordsignup.match(/[a-zA-Z]/g)) || this.state.passwordsignup.length < 8 || this.state.passwordsignup.toLowerCase().indexOf(this.state.usernamesignup.toLowerCase()) > -1 || this.state.passwordsignup !== this.state.passwordsignup_confirm || this.state.mobileNumber === "" || this.state.mobilealreadyexist || !this.state.mobileNumberisValid || (!this.state.sameAsMobile && (this.state.whatsUpNumber === "" || !this.state.whatsUpNumberisValid)) || this.state.emailsignup === "" || !(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.state.emailsignup.trim())) || !this.state.tncChecked || this.state.usernamealreadyexist
    return (
      this.state.setpwdpasscode.match(/[0-9]/g) &&
        this.state.setpwdpasscode.match(/[a-zA-Z]/g) &&
        this.state.setpwdpasscode.length >= 8 &&
        // this.state.setpwdpasscode !== this.state.setpwdoldpasscode &&
        (
          !!this.state.uid ?
            this.state.setpwdpasscode
              .toLowerCase()
              .indexOf(this.state.uid.toLowerCase()) === -1 : true) 
        // && this.state.setpwdpasscode === this.state.setpwdrepasscode
        ? false
        : true
    );
    //return false;
  }


  updateCaptchaData(requestId, solution, expiryCaptcha) {
    this.setState({
      requestId: requestId,
      captchaSolution: solution,
      expiryCaptcha: expiryCaptcha
    });
  }

  render() {
    return (
      <>
        <div
          id="marketbetspopup"
          className="modal fade show sign-up-form sign-up-form-new"
          style={{ display: "block" }}
          tabIndex="-1"
          role="dialog"
          aria-labelledby="myModalLabel"
          aria-modal="true"
        >
          <div className="modal-dialog  modal-dialog-scrollable modal-sm">
            <div className="modal-content">
              {/* <div className="modal-header">
                <button onClick={() => { this.props.hidePopup(); }} type="button" className="close text-black" data-dismiss="modal" aria-hidden="true"  >  × </button>
              </div> */}
              <div className="modal-body" id="content">
                {this.state.setPassword ? (
                  <h5 className="modal-title mt-0 text-black text-center" id="myModalLabel"  >  Set Password <button onClick={() => { logout(true); this.props.hidePopup(); }} type="button" className="close text-black" data-dismiss="modal" aria-hidden="true"  >  × </button></h5>
                ) : (
                  <>
                    {this.state.forgotPassword ? (
                      <h5 className="modal-title mt-0 text-black text-center " id="myModalLabel" > Forgot Password? <button onClick={() => { this.props.hidePopup(); }} type="button" className="close text-black" data-dismiss="modal" aria-hidden="true"  >  × </button></h5>
                    ) : (
                      <>
                        <div>
                          <h5 className="modal-title mt-0 text-black text-center font-bold" id="myModalLabel"  > Login <button onClick={() => { this.props.hidePopup(); }} type="button" className="close text-black" data-dismiss="modal" aria-hidden="true"  >  × </button> </h5>

                        </div>
                        {LBLTYPE === 'b2c' &&
                          <div className="text-center">
                            <span className="subtitle-text mr-1">
                              Not a member yet?
                            </span>
                            <span className="subtitle-text">
                              |
                              <a
                                href="#"
                                className="link-over-white ml-1"
                                onClick={() => {
                                  if(LoginAndRegisterHaveURL){
                                    window.location.href = '/register';
                                  } else {
                                    this.props.togglePopupBetweenLoginSignup("JoinNow");
                                  }
                                }}
                              >
                                Sign Up
                              </a>
                            </span>
                          </div>
                        }
                      </>
                    )}
                  </>
                )}

                {this.state.setPassword ? (
                  <>
                    <div className="margin-bottom-5px mt-3">
                      <label
                        htmlFor="setpwdoldpasscode"
                        className="youpasswd"
                        data-icon="p"
                      >
                        Old Password{" "}
                      </label>
                      <input
                        className="field"
                        tabIndex={2}
                        type="Password"
                        value={this.state.setpwdoldpasscode}
                        name="setpwdoldpasscode"
                        id="setpwdoldpasscode"
                        onChange={(e) => {
                          this.onChange(e);
                        }}
                        placeholder="Old Password"
                      />
                      <span
                        onClick={() => {
                          this.onPasswordVisible("setpwdoldpasscode");
                        }}
                        style={{ marginTop: "-30px", marginRight: "8px" }}
                        className="float-right"
                      >
                        {!!this.state.setpwdoldpasscodeVisible ? (
                          <i className="fa fa-eye" aria-hidden="true"></i>
                        ) : (
                          <i className="fa fa-eye-slash" aria-hidden="true"></i>
                        )}
                      </span>
                    </div>

                    <div className="margin-bottom-5px mt-3">
                      <label
                        htmlFor="setpwdpasscode"
                        className="youpasswd"
                        data-icon="p"
                      >
                        New Password{" "}
                      </label>
                      <input
                        className="field"
                        tabIndex={3}
                        type="Password"
                        value={this.state.setpwdpasscode}
                        name="setpwdpasscode"
                        id="setpwdpasscode"
                        onChange={(e) => {
                          this.onChange(e);
                        }}
                        placeholder="New Password"
                      />
                      <span
                        onClick={() => {
                          this.onPasswordVisible("setpwdpasscode");
                        }}
                        style={{ marginTop: "-30px", marginRight: "8px" }}
                        className="float-right"
                      >
                        {!!this.state.setpwdpasscodeVisible ? (
                          <i className="fa fa-eye" aria-hidden="true"></i>
                        ) : (
                          <i className="fa fa-eye-slash" aria-hidden="true"></i>
                        )}
                      </span>
                      {!!this.state.setpwdpasscode && (
                        <>
                          <ul>
                            <li id="digit" className="success-text">
                              <i className="fa fa-check"></i> At least 1 digit
                            </li>
                            <li id="scharacter" className="">
                              <i className="fa fa-check"></i> At least 1
                              character
                            </li>
                            <li id="minlength" className="">
                              <i className="fa fa-check"></i> Minimum 8
                              characters
                            </li>
                          </ul>
                        </>
                      )}
                    </div>
                    <div className="margin-bottom-5px mt-3">
                      <label
                        htmlFor="setpwdrepasscode"
                        className="youpasswd"
                        data-icon="p"
                      >
                        Confirm Password{" "}
                      </label>
                      <input
                        className="field"
                        tabIndex={4}
                        type="Password"
                        value={this.state.setpwdrepasscode}
                        name="setpwdrepasscode"
                        id="setpwdrepasscode"
                        onChange={(e) => {
                          this.onChange(e);
                        }}
                        onKeyUp={(e) => {
                          this.handleSetPasswordKey(e);
                        }}
                        placeholder="Confirm Password"
                      />
                      <span
                        onClick={() => {
                          this.onPasswordVisible("setpwdrepasscode");
                        }}
                        style={{ marginTop: "-30px", marginRight: "8px" }}
                        className="float-right"
                      >
                        {!!this.state.setpwdrepasscodeVisible ? (
                          <i className="fa fa-eye" aria-hidden="true"></i>
                        ) : (
                          <i className="fa fa-eye-slash" aria-hidden="true"></i>
                        )}
                      </span>
                    </div>
                  </>
                ) : (
                  <>
                    {this.state.forgotPassword ? (
                      <>
                        {ISOTPPASSWORD ? (
                          <div>
                            {/* <div className='mb-3'>
                                                                    <label htmlFor="mobileNumber" className="uname" data-icon="u">Registered Mobile<small className='float-right'></small></label>
                                                                    <PhoneInput specialLabel="" country={'in'} value={this.state.mobileNumber} name="mobileNumber" onChange={(inputNumber, country) => { this.onPhoneNumberChange(inputNumber, country, 'mobileNumber') }} />
                                                                </div> */}

                            <div className="mb-3">
                              <label
                                htmlFor="usernameforgot"
                                className="uname"
                                data-icon="u"
                              >
                                User ID
                              </label>
                              <input
                                className="field lowercase"
                                name="usernameforgot"
                                required="required"
                                type="text"
                                onChange={(e) => this.onChange(e)}
                                value={this.state.usernameforgot}
                                placeholder="User ID"
                              />
                              {this.state.usernameforgot !== "" &&
                                this.state.usernameforgot.indexOf(" ") > -1 ? (
                                <label
                                  id="usernospacelbl"
                                  className="signup-validation-text error-text"
                                  style={{ color: "red" }}
                                >
                                  This field cannot have space.
                                </label>
                              ) : null}
                              {this.state.usernameforgot !== "" &&
                                this.state.usernameforgot.length < 6 ? (
                                <label
                                  id="userminlengthlbl"
                                  className="signup-validation-text error-text"
                                  style={{ color: "red" }}
                                >
                                  Minimum 6 characters
                                </label>
                              ) : null}
                            </div>
                            {this.state.otpSent > 0 && (
                              <>
                                <div className="mb-1">
                                  <span>
                                    OTP has been sent to{" "}
                                    {this.state.otpsentnumber}
                                  </span>
                                </div>
                                {/* <div className='mb-1 d-flex-number'><span></span><span className='get-otp' onClick={()=> this.sendOTP()} disabled = {}>Get OTP</span></div> */}
                                {/* <div className='mb-1 d-flex-number'><span></span><span className='get-otp' onClick={()=> this.sendOTP()} >Get OTP</span></div> */}
                              </>
                            )}
                            {this.state.otpSent > 0 && (
                              <>
                                <div className="mb-3">
                                  <label
                                    htmlFor="fgtOtp"
                                    className="uname"
                                    data-icon="u"
                                  >
                                    Enter OTP
                                  </label>
                                  <input
                                    className="field"
                                    type="text"
                                    value={this.state.fgtOtp}
                                    name="fgtOtp"
                                    maxlength="6"
                                    onChange={(e) => this.onChange(e)}
                                    onBlur=""
                                    placeholder="Enter OTP"
                                  />
                                  {this.state.resendOtp > 0 ? (
                                    <div
                                      className="resend-otp"
                                      style={{ textDecoration: "none" }}
                                    >
                                      <a href="#">
                                        Resend OTP in {this.state.resendOtp}{" "}
                                        secs
                                      </a>
                                    </div>
                                  ) : (
                                    <div className="resend-otp">
                                      <a
                                        href="#"
                                        onClick={() => {
                                          this.sendOTP(true);
                                        }}
                                      >
                                        Resend OTP
                                      </a>
                                    </div>
                                  )}
                                </div>
                                <>
                                  <div className="margin-bottom-5px mt-3">
                                    <label
                                      htmlFor="fgtpwdpasscode"
                                      className="youpasswd"
                                      data-icon="p"
                                    >
                                      New Password{" "}
                                    </label>
                                    <input
                                      className="field"
                                      tabIndex={3}
                                      type="Password"
                                      value={this.state.fgtpwdpasscode}
                                      name="fgtpwdpasscode"
                                      id="fgtpwdpasscode"
                                      onChange={(e) => {
                                        this.onChange(e);
                                      }}
                                      placeholder="New Password"
                                    />
                                    <span
                                      onClick={() => {
                                        this.onPasswordVisible(
                                          "fgtpwdpasscode"
                                        );
                                      }}
                                      style={{
                                        marginTop: "-30px",
                                        marginRight: "8px",
                                      }}
                                      className="float-right"
                                    >
                                      {!!this.state.fgtpwdpasscodeVisible ? (
                                        <i
                                          className="fa fa-eye"
                                          aria-hidden="true"
                                        ></i>
                                      ) : (
                                        <i
                                          className="fa fa-eye-slash"
                                          aria-hidden="true"
                                        ></i>
                                      )}
                                    </span>
                                    {!!this.state.fgtpwdpasscode && (
                                      <>
                                        <ul>
                                          <li
                                            id="digit"
                                            className="success-text"
                                          >
                                            <i className="fa fa-check"></i> At
                                            least 1 digit
                                          </li>
                                          <li id="scharacter" className="">
                                            <i className="fa fa-check"></i> At
                                            least 1 character
                                          </li>
                                          <li id="minlength" className="">
                                            <i className="fa fa-check"></i>{" "}
                                            Minimum 8 characters
                                          </li>
                                        </ul>
                                      </>
                                    )}
                                  </div>
                                  <div className="margin-bottom-5px mt-3">
                                    <label
                                      htmlFor="fgtpwdrepasscode"
                                      className="youpasswd"
                                      data-icon="p"
                                    >
                                      Confirm Password{" "}
                                    </label>
                                    <input
                                      className="field"
                                      tabIndex={4}
                                      type="Password"
                                      value={this.state.fgtpwdrepasscode}
                                      name="fgtpwdrepasscode"
                                      id="fgtpwdrepasscode"
                                      onChange={(e) => {
                                        this.onChange(e);
                                      }}
                                      onKeyUp={(e) => {
                                        this.handleSetPasswordKey(e);
                                      }}
                                      placeholder="Confirm Password"
                                    />
                                    <span
                                      onClick={() => {
                                        this.onPasswordVisible(
                                          "fgtpwdrepasscode"
                                        );
                                      }}
                                      style={{
                                        marginTop: "-30px",
                                        marginRight: "8px",
                                      }}
                                      className="float-right"
                                    >
                                      {!!this.state.fgtpwdrepasscodeVisible ? (
                                        <i
                                          className="fa fa-eye"
                                          aria-hidden="true"
                                        ></i>
                                      ) : (
                                        <i
                                          className="fa fa-eye-slash"
                                          aria-hidden="true"
                                        ></i>
                                      )}
                                    </span>
                                  </div>
                                </>
                              </>
                            )}
                            {this.state.otpSent > 0 ? (
                              <div className="signin button mx-auto">
                                <button
                                  className="btn-type-submit"
                                  // disabled={this.validateForForgot()}
                                  onClick={() => {
                                    this.submitForgotPassword();
                                  }}
                                >
                                  {this.state.buttonLoader && (
                                    <svg
                                      className="spinner mr-2"
                                      viewBox="0 0 50 50"
                                    >
                                      <circle
                                        className="path"
                                        cx="25"
                                        cy="25"
                                        r="20"
                                        fill="none"
                                        strokeWidth="5"
                                      ></circle>
                                    </svg>
                                  )}
                                  Submit
                                </button>
                              </div>
                            ) : (
                              <div className="signin button mx-auto">
                                <button
                                  className="btn-type-submit"
                                  disabled={
                                    this.state.usernameforgot === "" ||
                                    this.state.usernameforgot.length < 6
                                  }
                                  onClick={() => {
                                    this.sendOTP();
                                  }}
                                >
                                  {this.state.buttonLoader && (
                                    <svg
                                      className="spinner mr-2"
                                      viewBox="0 0 50 50"
                                    >
                                      <circle
                                        className="path"
                                        cx="25"
                                        cy="25"
                                        r="20"
                                        fill="none"
                                        strokeWidth="5"
                                      ></circle>
                                    </svg>
                                  )}
                                  Forget Password
                                </button>
                              </div>
                            )}
                          </div>
                        ) : (
                          <form action="">
                            <div className="forgot-text">
                              Contact our chat support team to recover your
                              password. Thank you!
                            </div>
                            <div className="signin button mx-auto">
                              <button
                                className="btn-type-submit"
                                onClick={() => {
                                  this.setState({
                                    forgotPassword: !this.state.forgotPassword,
                                  });
                                }}
                              >
                                Back
                              </button>
                            </div>
                          </form>
                        )}
                      </>
                    ) : (
                      <form action="">
                        <div className="margin-bottom-5px">
                          <label
                            htmlFor="usernameforgot"
                            className="uname"
                            data-icon="u"
                          >
                            User ID
                          </label>
                          <input
                            className="field lowercase"
                            tabIndex={1}
                            autoFocus
                            value={this.state.uid}
                            name="uid"
                            autoCorrect="off"
                            autoCapitalize="off"
                            autoComplete="off"
                            type="text"
                            onChange={(e) => this.onChange(e)}
                            placeholder="User ID"
                          />
                        </div>
                        <div className="d-flex justify-content-end mb-1 signin">
                          <input
                            type="checkbox"
                            required="required"
                            name="tncChecked"
                            checked={this.state.rememberMe}
                            onClick={() => {
                              this.setState({
                                rememberMe: !this.state.rememberMe,
                              });
                            }}
                            onChange={(e) => { }}
                          />{" "}
                          <span className="signup-validation-text">
                            {" "}
                            Remember me
                          </span>
                        </div>
                        <div className="margin-bottom-5px login-password-div">
                          <label
                            htmlFor="passwordsignup"
                            className="youpasswd"
                            data-icon="p"
                          >
                            Password{" "}
                          </label>
                          <input
                            className="field p-relative"
                            tabIndex={2}
                            type="Password"
                            value={this.state.passcode}
                            name="passcode"
                            id="passcode"
                            onChange={(e) => {
                              this.onChange(e);
                            }}
                            onKeyUp={(e) => {
                              this.handleKey(e);
                            }}
                            placeholder="Password"
                          />
                          <span
                            onClick={() => {
                              this.onPasswordVisible("passcode");
                            }}
                            className="float-right login-password-div-span-i"
                          >
                            {!!this.state.passcodeVisible ? (
                              <i className="fa fa-eye" aria-hidden="true"></i>
                            ) : (
                              <i
                                className="fa fa-eye-slash"
                                aria-hidden="true"
                              ></i>
                            )}
                          </span>
                        </div>
                        {LBLTYPE === 'b2c' &&
                          <div className="d-flex justify-content-end mb-3">
                            <a
                              className="link-over-white signup-validation-text f-color-white"
                              onClick={() => {
                                this.setState({
                                  forgotPassword: !this.state.forgotPassword,
                                });
                              }}
                            >
                              Forgot Password
                            </a>
                          </div>
                        }
                        {PotanuCaptcha ?
                          <CaptchaComp updateCaptchaData={(requestId, solution, expiryCaptcha) => this.updateCaptchaData(requestId, solution, expiryCaptcha)} onKeyUp={(e)=>this.handleKey(e)}/>
                        :
                          <ReCAPTCHA ref={recaptchaRef} sitekey={ReCAPTCHA_KEY} size={"invisible"}/>
                        }
                      </form>
                    )}
                  </>
                )}
              </div>
              {this.state.setPassword ? (
                <div className="modal-footer" id="content1">
                  <button
                    className="btn-type-submit"
                    onClick={() => {
                      this.setPasswordSubmit();
                    }}
                    // disabled={
                    //   this.validateForSetupPassword()
                    // }
                  >
                    <span className="">Submit</span>
                  </button>
                </div>
              ) : (
                <>
                  {!this.state.forgotPassword && (
                    <div className="modal-footer" id="content1">
                      <div className="signin button mx-auto">
                        <button
                          className="btn-type-submit"
                          disabled={this.validateForSubmit() || this.state.buttonLoader}
                          onClick={() => {
                            this.signIn();
                          }}
                        >
                          {this.state.buttonLoader && (
                            <svg className="spinner mr-2" viewBox="0 0 50 50">
                              <circle
                                className="path"
                                cx="25"
                                cy="25"
                                r="20"
                                fill="none"
                                strokeWidth="5"
                              ></circle>
                            </svg>
                          )}
                          <span className="">Login</span>
                        </button>
                        
                        {/* {this.state.clientWidth < 768 && <button type="submit" className="btn-type-submit" onClick={() => { window.location.href = `https://apk.${BASE_IMAGE_PATH_ONLY}/${APK_FILE_NAME}.apk` }}><i className="fa fa-android pr-2" aria-hidden="true"></i>Download Apk</button>} */}
                      </div>
                      {LoginWithDemo &&
                        <div className="signin button mx-auto">
                          <button
                            className="btn-type-submit"
                            onClick={() => {
                              this.signInApi(null, true)
                            }}
                          >
                            {this.state.demoButtonLoader && (
                              <svg className="spinner mr-2" viewBox="0 0 50 50">
                                <circle
                                  className="path"
                                  cx="25"
                                  cy="25"
                                  r="20"
                                  fill="none"
                                  strokeWidth="5"
                                ></circle>
                              </svg>
                            )}
                            <span className="">Demo ID</span>
                          </button>
                        </div>
                      }
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
          <div
            className="modal-backdrop fade show"
            onClick={() => {
              this.props.hidePopup("Login");
            }}
          ></div>
        </div>
      </>
    );
  }
}
function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {};
}
export default connect(mapStateToProps, mapDispatchToProps)(Loginpopup);
